import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  // ... (기존 설정 값 유지) ...
  apiKey: "AIzaSyBCVKFuNNUL-r4RVm9QVu2FBSxXti-kZjc",
  authDomain: "jomunamgi.firebaseapp.com",
  projectId: "jomunamgi",
  storageBucket: "jomunamgi.firebasestorage.app",
  messagingSenderId: "655303459950",
  appId: "1:655303459950:web:ff35117f65e752ab51527f",
  measurementId: "G-MLL0E610HJ"
};

const app = initializeApp(firebaseConfig);

// [수정] 이름을 바꿔서 내보냅니다 (강제 갱신 유도)
export const fireAuth = getAuth(app);
export const fireDB = getFirestore(app);
export const appId = 'my-law-app';